import React from 'react';
import Footer from './Footer';
import Header from './Header';
import Helmet from 'react-helmet'
import Favicon from '../../images/logo.svg'

const Layout = ({ children }) => {
  return (
    <>
    <Helmet>
      <link rel="icon" href={Favicon} />
    </Helmet>
      <Header />
      <main className="text-gray-900">{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
